import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Router } from '@angular/router';

@Component({
  selector: 'app-campaign-projects',
  templateUrl: './campaign-projects.component.html',
  styleUrls: ['./campaign-projects.component.scss']
})
export class CampaignProjectsComponent implements OnInit {

  authToken = localStorage.getItem("token")
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));

  leadDeliveryList: any;
  showComponentLoader: boolean = true;

  projectRowData:any;

  headerStats:any;
  campaignProjects:any;
  anyRechurnProject = false;
  allDetails:any;
  // showComponentLoader = true;

  constructor(
    private _serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CampaignProjectsComponent>,
    private datePipe: DatePipe,
    private _router:Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.allDetails = this.data;
    // console.log(data)
    // this.projectRowData = data;
  }
  
  ngOnInit() {
  this.getCampaignProject();
 
  // console.log(this.anyRechurnProject)
  }
  getCampaignProject(){
    let url = 'get_campaign_projects?campaign_id='+this.data.id;
    this._serverService.getCampaignProjectByCampaignId(url,this.authToken).subscribe((data: any) => {
      this.campaignProjects = data.data.projects;
     
      // console.log(this.campaignProjects)
      this.anyRechurnProject = this.anyChurnProject();
      this.showComponentLoader = false
    });
   
  }


  close() {
    this.dialogRef.close();
}
openProject(project){
  sessionStorage.setItem("projectInfo", JSON.stringify(project))
  // this._router.navigate(['page/project/leads/'+project.id,'_blank']);
  window.open(`page/project/leads/${project.id}`, '_blank');
  this.dialogRef.close();
}
anyChurnProject(){
  const found = this.campaignProjects.find(item => item.tag === 'Re churn');
  return found ? found.tag : null;
}
}
